import PropTypes from 'prop-types';
import React from 'react';

function FloatWrapper(props) {

    let className = props.className

    switch (props.autoFloat) {

        case "left":
            className += " float-wrapper--left"
            break

        case "right":
            className += " float-wrapper--right"
            break

        default:
            break

    }

    if (props.classSuffix) {
        className += " " + props.classSuffix;
    }

    return (
        <div className={className}>
            {props.children}
        </div>
    );

}

FloatWrapper.propTypes = {
    className: PropTypes.string,
    classSuffix: PropTypes.string,
    autoFloat: PropTypes.string
};

FloatWrapper.defaultProps = {
    className: "float-wrapper"
};

export default FloatWrapper


/** WEBPACK FOOTER **
 ** ./src/components/FloatWrapper.js
 **/